import { gsap, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

class ChargeAnim {
  constructor() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Prevent the animation from running if the user has requested reduced motion
    if (!prefersReducedMotion || prefersReducedMotion.matches) {
      return;
    }
    this.body = document.documentElement;
    this.items = gsap.utils.toArray('.js-charge-item');
    this.images = gsap.utils.toArray('.js-image-swap');
    this.animateImages();

    if (window.innerWidth > 768) {
      this.handleIntersection();
    }
  }

  handleIntersection() {
    this.items.forEach(entry => {
      const innerText = entry.children[0];
      const tl = gsap.timeline();

      gsap.config({
        nullTargetWarn: false,
      });

      tl.from(innerText, {
        duration: 1,
        y: '30px',
        filter: 'blur(3px)',
        opacity: 0,
        ease: 'power2.out',
      }).to(innerText, {
        duration: 1,
        delay: -1,
        y: '0',
        filter: 'blur(0)',
        opacity: 1,
        ease: 'power2.out',
      });

      ScrollTrigger.create({
        animation: tl,
        trigger: entry,
        scrub: true,
        start: 'bottom bottom-=100',
        end: `center center`,
      });
    });
  }

  animateImages() {
    const staggerAmount = (window.innerHeight - this.images[0].offsetHeight) / this.images.length;
    const animationDuration = 0.2; // Change this value to adjust the duration

    this.images.forEach((img, i) => {
      gsap.timeline({
        scrollTrigger: {
          trigger: img,
          start: () => `bottom+=${staggerAmount * i} bottom`, // Start fading in after scrolling ~50px per image
          end: () => `+=${50}`, // Hold for 50px of scroll, then allow for the next image
          toggleActions: 'play none none reverse',
          onEnter: () => gsap.to(img, { autoAlpha: 1, duration: animationDuration }),
          onLeaveBack: () => gsap.to(img, { autoAlpha: 0, duration: animationDuration }),
        },
      });
    });
  }
}

export default ChargeAnim;
